import { MenuOptionGroupBasicWithItems } from "client/jspPlatformExperiment";
import React, { FC } from "react";
import { Box } from "@mui/material";
import styled from "styled-components";
import Typography from "@mui/material/Typography";
import MenuItemViewBox from "components/menu/ui/common/MenuItemViewBox";
import { isMenuItemBasicWithSides } from "models/menu/menu";

const StyledMenuSectionBox = styled(Box)`
  padding: 0.5rem 0 0.5rem 1rem;
`;

const MenuOptionGroupHeader = styled(Typography)`
  font-size: 0.8rem;
  font-weight: 500;
  color: rgb(120, 203, 255);
  border-bottom: 0.1rem solid rgb(120, 203, 255);
`;

const SideGroupHeader = styled(MenuOptionGroupHeader)`
  width: fit-content;
`;

const MenuSectionHeader = styled(MenuOptionGroupHeader)`
  padding: 0.2rem 0.5rem 0 0.5rem;
`;

const StyledMenuMainItem = styled(Box)`
  padding: 0.25rem 0 0.25rem 0.25rem;
`;

const StyledMenuSideItem = styled(Box)`
  padding: 0 0 0 0.25rem;
`;

interface MenuSectionViewBoxProps {
  section: MenuOptionGroupBasicWithItems;
  isSideOptionGroup?: boolean;
}

const MenuSectionViewBox: FC<MenuSectionViewBoxProps> = ({
  section,
  isSideOptionGroup = false,
}) => {
  // display menu section
  return (
    <StyledMenuSectionBox>
      {isSideOptionGroup ? (
        <SideGroupHeader>{section.name}</SideGroupHeader>
      ) : (
        <MenuSectionHeader>{section.name}</MenuSectionHeader>
      )}
      {section.options.map((item) => (
        <StyledMenuMainItem key={item.id}>
          {isMenuItemBasicWithSides(item) ? (
            <MenuItemViewBox menuItem={item} />
          ) : null}
          {isMenuItemBasicWithSides(item)
            ? item.side_option_groups?.map((side) => (
                <StyledMenuSideItem key={side.id}>
                  <MenuSectionViewBox section={side} isSideOptionGroup />
                </StyledMenuSideItem>
              ))
            : null}
        </StyledMenuMainItem>
      ))}
    </StyledMenuSectionBox>
  );
};

export default MenuSectionViewBox;
